export const AdminTypes = {
  SET_PROPERTY: 'SET_PROPERTY',
  SET_OWNER: 'SET_OWNER',
}
